<template>
    <div>This is a fake component registered globally with non-scoped style in order to make it available everywhere.</div>
</template>

<style lang="scss">
    @use '../overrides/datatable';
</style>
